import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {EmptyStateSmall} from 'shells/empty-states/empty-state-small';
import {Illustration} from 'shells/illustrations/illustration';

import {getReportDefaultFields} from '../../../reports/report-constants';
import type {ReportURLParams} from '../../../reports/report-types';

import {EntityListContainer} from '../../entity-lists/entity-list-container';

import {AddedStatusFilter} from './added-status-filter';
import {CompaniesListProvider} from './companies-list-provider';
import {companiesFieldFilterFunction} from './helpers';

const UNFILTERED_COUNT_THRESHOLD = 1;

type Props = {
    filters: FilterObject[];
    search: string;
    selectedPage: number;
    selectedSortField: string;
    selectedFields: string[];
    urlParams: ReportURLParams<'mcfxcompanies'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
    onRemoveAllFilters: () => void;
    onOpenSidebar: (id: string) => void;
};

export function CompaniesListContainer(props: Props) {
    const {onOpenSidebar, ...restProps} = props;

    return (
        <CompaniesListProvider>
            <EntityListContainer
                {...restProps}
                entityType='mcfxcompanies'
                customEmptyStateComponent={
                    <EmptyStateSmall
                        title='No visitors found'
                        subtitle='Analytics is active, but we haven’t seen any site visitors yet'
                        icon={
                            <div style={{width: '75px'}}>
                                <Illustration
                                    src='magnifying-glass-empty-state'
                                    width='100%'
                                    height='100%'
                                />
                            </div>
                        }
                    />
                }
                graduatedFilters={
                    <AddedStatusFilter
                        // Note, this is the prop, not the filtered filters.
                        // We want to reflect the "default" filter here
                        filters={props.filters}
                        onParamChange={props.onParamChange}
                        urlParams={props.urlParams}
                    />
                }
                fieldFilterFunction={companiesFieldFilterFunction}
                unfilteredCount={
                    // if searching, increase unfiltered count past the threshold so that the "no results with filters"
                    // message is shown rather than the empty state - otherwise keep unfilteredCount undefined so that
                    // custom empty state will be shown if there are no rows displayed without filters
                    props.search ? UNFILTERED_COUNT_THRESHOLD + 1 : undefined
                }
                unfilteredCountThreshold={UNFILTERED_COUNT_THRESHOLD}
                scrollContainerSelector='#companies-list'
                defaultFields={getReportDefaultFields('mcfxcompanies').split(',')}
                hideSearch={false}
                handleRowClick={onOpenSidebar}
                hasUnlockCompaniesButton={false}
                hideSelectionCheckboxes={true}
            />
        </CompaniesListProvider>
    );
}
